import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiMenu, FiX } from 'react-icons/fi';
import Button from '../ui/Button';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'The Problem', href: '#mirror' },
    { name: 'How It Works', href: '#framework' },
    { name: 'Outcomes', href: '#outcomes' },
    { name: 'About', href: '#about' },
  ];

  const bookSession = () => {
    window.open('https://topmate.io/mugdha_clarity90/2028348', '_blank');
  };

  const goToAudit = () => {
    window.open('/audit', '_blank');
  };

  return (
    <header
      className={`fixed top-0 w-full z-50 transition-all duration-500 ${
        isScrolled ? 'bg-brand-deep/95 backdrop-blur-md py-4 shadow-sm' : 'bg-transparent py-6'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center">

        <a href="#" className="relative z-50 flex items-center">
          <img
            src="https://media-manager-c.questera.ai/greta-media/950656ff8acc2b4c64dfb2a5e756971f95d9a65d0f8c5ef3b6e107600fb8dee58cb5b46485e4f90e0b9e2ba9c3364607/images/aW1hZ2UvcG5n/e97e546a8eb475f7a54f9de3bf45f99b.png"
            alt="Clarity90 Logo"
            className="h-14 md:h-16 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="text-sm text-brand-cream/80 hover:text-brand-cream transition-colors"
            >
              {link.name}
            </a>
          ))}
          <button
            onClick={goToAudit}
            className="text-sm font-semibold text-brand-terra hover:text-brand-terra/80 transition-colors tracking-wide border border-brand-terra/40 hover:border-brand-terra px-4 py-2 rounded-sm"
          >
            Free Audit
          </button>
          <Button variant="primary" className="py-2.5 px-6" onClick={bookSession}>
            Book a Session
          </Button>
        </nav>

        {/* Mobile Toggle */}
        <button
          className="md:hidden text-brand-cream relative z-50 p-2"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>

        {/* Mobile Menu */}
        <AnimatePresence>
          {mobileMenuOpen && (
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              className="absolute top-0 left-0 w-full h-screen bg-brand-deep flex flex-col items-center justify-center gap-8 z-40"
            >
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className="font-serif text-3xl text-brand-cream hover:text-brand-terra transition-colors"
                >
                  {link.name}
                </a>
              ))}
              <button
                onClick={() => { setMobileMenuOpen(false); goToAudit(); }}
                className="font-serif text-3xl text-brand-terra hover:text-brand-terra/80 transition-colors"
              >
                Free Audit
              </button>
              <Button variant="primary" onClick={() => { setMobileMenuOpen(false); bookSession(); }}>
                Book a Session
              </Button>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </header>
  );
}